'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002429 from "./presto.-Groups-View$$anon$29.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$28() {
  this.aXL = null;
  this.aXD = null;
  this.aXE = false;
  this.aXM = null;
  this.aXN = false;
  this.aXQ = null;
  this.aXJ = null;
  this.aXK = false;
  this.aXF = null;
  this.aXG = false;
  this.aXH = null;
  this.aXI = false;
  this.aXO = false;
  this.aXP = false;
  this.aXL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aXQ = "Role";
}
export { $c_Lpresto_GroupsView$$anon$28 as $c_Lpresto_GroupsView$$anon$28 };
$p = $c_Lpresto_GroupsView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$28;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$28() {
}
export { $h_Lpresto_GroupsView$$anon$28 as $h_Lpresto_GroupsView$$anon$28 };
$h_Lpresto_GroupsView$$anon$28.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aXL;
});
$p.L = (function() {
  if ((!this.aXE)) {
    this.aXD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aXE = true;
  }
  return this.aXD;
});
$p.O = (function() {
  if ((!this.aXN)) {
    this.aXM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aXN = true;
  }
  return this.aXM;
});
$p.E = (function() {
  return this.aXQ;
});
$p.t = (function() {
  if ((!this.aXK)) {
    this.aXJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXK = true;
  }
  return this.aXJ;
});
$p.M = (function() {
  if ((!this.aXG)) {
    this.aXF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nM(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXG = true;
  }
  return this.aXF;
});
$p.Q = (function() {
  if ((!this.aXI)) {
    this.aXH = new $j_presto$002e$002dGroups$002dView$0024$0024anon$002429.$c_Lpresto_GroupsView$$anon$29();
    this.aXI = true;
  }
  return this.aXH;
});
$p.w = (function() {
  if ((!this.aXP)) {
    this.aXO = false;
    this.aXP = true;
  }
  return this.aXO;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee283) => ((p) => \u03b4scrutinee283.nG(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_GroupsView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$28, "presto.GroupsView$$anon$28", ({
  JJ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$28 as $d_Lpresto_GroupsView$$anon$28 };
//# sourceMappingURL=presto.-Groups-View$$anon$28.js.map
